import { render, staticRenderFns } from "./DropReceiverAdmin.vue?vue&type=template&id=0b401efb&scoped=true"
import script from "./DropReceiverAdmin.vue?vue&type=script&lang=js"
export * from "./DropReceiverAdmin.vue?vue&type=script&lang=js"
import style0 from "./DropReceiverAdmin.vue?vue&type=style&index=0&id=0b401efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b401efb",
  null
  
)

export default component.exports